import { Storage, LOCAL_STORAGE } from './storage';

export function createSpotStorage(storageKey, storageVersion = 1) {
  var storage = new Storage([LOCAL_STORAGE]);

  class SpotStorage {
    constructor(spotId) {
      this.spotId = spotId;
    }
    setItem(key, value, version) {
      var store = storage.getItem(storageKey, storageVersion);

      if (!store) {
        store = {};
      }

      if (!store[this.spotId]) {
        store[this.spotId] = {};
      }

      var data = { data: value };
      if (version) {
        data.version = version;
      }

      store[this.spotId][key] = data;

      storage.setItem(storageKey, store, storageVersion);
    }
    getItem(key, version) {
      var item = null;
      var store = storage.getItem(storageKey, storageVersion);
      if (store && store[this.spotId]) {
        var obj = store[this.spotId][key];
        var isValidVersion = !version || (obj && obj.version && obj.version === version);
        if (isValidVersion && obj && obj.data) {
          item = obj.data;
        }
      }
      return item;
    }
  }

  return SpotStorage;
}
